<div class="bg-img">
  <div class="cross-btn" (click)="goBack()">
    <img src="/assets/icon/round-cross.svg" alt="" />
  </div>
  <div class="content">
    <div class="upper-text">
      <h5>{{ data.title }}</h5>
      <h4>{{ data.extract }}</h4>
      <p>{{ data.html_content_top }}</p>
    </div>
    <div [innerHTML]="data?.html_content_bottom | safeHtml"></div>
    <div class="view-all-btn-wrap">
      <ion-button class="" (click)="goToVoucher(data?.button_link)"> Claim Gift </ion-button>
    </div>
  </div>
</div>